import {
  AppBar,
  Box,
  Button,
  Container,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import React from "react";
import { Link, Route, Routes } from "react-router-dom";

import AccountDeletionRequest from "./pages/AccountDeletionRequest";
import AccountDeletionRequested from "./pages/AccountDeletionRequested";
import AccountDeletionSuccess from "./pages/AccountDeletionSuccess";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";

const Home: React.FC = () => (
  <Container sx={{ py: 6 }}>
    <Typography variant="h3" gutterBottom>
      Mercado Ágil
    </Typography>
    <Typography variant="body1" gutterBottom>
      Bem-vindo! Use o menu para navegar pelas políticas e solicitar exclusão de
      conta.
    </Typography>
  </Container>
);

const NotFound: React.FC = () => (
  <Container sx={{ py: 6 }}>
    <Typography variant="h4" gutterBottom>
      Página não encontrada
    </Typography>
    <Button component={Link} to="/" variant="contained">
      Ir para início
    </Button>
  </Container>
);

const App: React.FC = () => {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const navItems = [
    { label: "Início", to: "/" },
    { label: "Política de Privacidade", to: "/politica-de-privacidade" },
    { label: "Termos de Uso", to: "/termos-de-uso" },
    { label: "Excluir conta", to: "/deletar-conta" },
  ];

  const toggleDrawer = (open: boolean) => () => setMobileOpen(open);

  return (
    <Box sx={{ minHeight: "100%" }}>
      <AppBar position="static">
        <Toolbar>
          <Typography
            variant="h6"
            component={Link}
            to="/"
            sx={{ flexGrow: 1, color: "inherit", textDecoration: "none" }}
          >
            Mercado Ágil
          </Typography>
          {/* Botões (desktop) */}
          <Box sx={{ display: { xs: "none", md: "flex" }, gap: 1 }}>
            {navItems.map((item) => (
              <Button
                key={item.to}
                color="inherit"
                component={Link}
                to={item.to}
              >
                {item.label}
              </Button>
            ))}
          </Box>
          {/* Menu mobile (hambúrguer) */}
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              color="inherit"
              aria-label="abrir menu"
              onClick={toggleDrawer(true)}
            >
              {/* Usando caractere para evitar dependência de @mui/icons-material */}
              <Typography component="span" variant="h5" sx={{ lineHeight: 1 }}>
                ☰
              </Typography>
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer Mobile */}
      <Drawer anchor="right" open={mobileOpen} onClose={toggleDrawer(false)}>
        <Box
          sx={{ width: 260 }}
          role="presentation"
          onClick={toggleDrawer(false)}
        >
          <List>
            {navItems.map((item) => (
              <ListItemButton key={item.to} component={Link} to={item.to}>
                <ListItemText primary={item.label} />
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Drawer>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
        <Route path="/termos-de-uso" element={<TermsOfUse />} />
        <Route path="/deletar-conta" element={<AccountDeletionRequest />} />
        <Route
          path="/deletar-conta/solicitado"
          element={<AccountDeletionRequested />}
        />
        <Route
          path="/deletar-conta/sucesso"
          element={<AccountDeletionSuccess />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Box>
  );
};

export default App;
